module.exports = __webpack_public_path__ + "img/Bank Mega Syariah.d3e58de8.png";